/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { Collapse, Spinner } from "reactstrap";

// Moment
import moment from "moment";

//Components
import MessageItem from "../../PreviousConversations/subcomponents/MessageItem/MessageItem";

//Redux
import { useSelector, useDispatch } from "react-redux";

//i18n
import { withTranslation } from "react-i18next";

// actions
import {
  getConsumerMessages,
  resetConsumerObj,
  getConsumerConversations,
} from "../../../../../store/operator/actions";

const EngagementHistoryArea = ({ chats, t, update }) => {
  const { messageConsumer } = useSelector((state) => state.Operator);

  const dispatch = useDispatch();
  const qtdDefault = 15;

  const [collapse, setCollapse] = useState();
  const [chatImages, setChatImages] = useState();

  const toggle = (id) => {
    collapse !== id ? setCollapse(id) : setCollapse(null);
  };

  const formatDate = (date) => {
    let d = moment(date);
    return d.format("DD MMM YYYY HH[h]mm");
  };

  const handleDayTitle = (msgs, pos) => {
    let lastDate = msgs[pos - 1]
      ? moment(msgs[pos - 1].sentTime).format("DD/MM/YYYY")
      : null;
    let date =
      msgs[pos] && msgs[pos].sentTime
        ? moment(msgs[pos].sentTime).format("DD/MM/YYYY")
        : null;
    let today = moment().format("DD/MM/YYYY");
    let yesterday = moment().subtract(1, "days").format("DD/MM/YYYY");

    let title =
      date !== null && date !== lastDate ? (
        <li className={`${checkEOF(msgs) && "mt-4"}`}>
          <div className="chat-day-title">
            <span className="title px-3">
              {date === today ? "Hoje" : date === yesterday ? "Ontem" : date}
            </span>
          </div>
        </li>
      ) : (
        ""
      );
    return title;
  };

  const updateChatImages = (id) => {
    let chats = messageConsumer?.messages;
    let msgs = chats && chats[id];
    let aux = [];

    Array.isArray(msgs) &&
      msgs.forEach((msg) => {
        if (msg?.files?.mime_type.split("/")[0] === "image") {
          aux.push(msg?.files?.file_url);
        }
      });

    aux = aux?.map((src) => {
      return { src };
    });
    aux = aux?.length > 0 ? aux : null;

    setChatImages(aux);
  };

  const checkEOF = (msgs) => {
    let totalMessages = msgs && msgs.length;
    if (!msgs) {
      return false;
    } else if (
      (msgs &&
        msgs.length > 0 &&
        msgs[msgs.length - 1].type &&
        msgs[msgs.length - 1].type === "eof") ||
      totalMessages % qtdDefault !== 0
    ) {
      return true;
    }
    return false;
  };

  const getMessages = (chatId, page, isPagination) => {
    let chats = messageConsumer && messageConsumer.messages;
    let msgs = chats && chats[chatId];

    if (
      !chats ||
      (chats && !msgs) ||
      (isPagination && chats && msgs && !checkEOF(msgs))
    ) {
      dispatch(getConsumerMessages(chatId ?? null, page, qtdDefault));
    }
  };

  const showMessages = (conversation) => {
    let chats = messageConsumer?.messages;
    let msgs = chats && chats[conversation?.conversationId];

    let loadMore = (
      <div
        className="w-100 py-4 text-center loadOlderMessages"
        onClick={() => {
          let totalMessages = msgs.length;
          let page = totalMessages / qtdDefault + 1;

          if (!checkEOF(msgs))
            getMessages(conversation.conversationId, page, true);
        }}
      >
        {t("Load older messages...")}
      </div>
    );

    let empty = (
      <div className="w-100 py-3 text-center">
        {t("No matching records found")}
      </div>
    );

    const getSender = (chat, msg) => {
      let agent = conversation?.users
        ? conversation?.users?.find((e) => e?.user_id === msg?.userId)
        : [];
      agent = agent?.user_name;

      return msg?.systemMessage
        ? t("System message")
        : msg.userId
        ? agent
          ? agent
          : t("Agent")
        : chat?.consumer?.name;
    };

    if (msgs) {
      return msgs?.length > 0
        ? msgs.map((msg, key) => (
            <>
              {key === 0 &&
                messageConsumer &&
                !(
                  messageConsumer?.data?.id === collapse &&
                  messageConsumer?.status?.get_messages?.loading
                ) &&
                !checkEOF(msgs) &&
                loadMore}
              {!(msg.type && msg.type === "eof") && (
                <div className={`d-flex flex-column`}>
                  {handleDayTitle(msgs, key)}
                  <MessageItem
                    isRight={msg?.userId || msg?.systemMessage ? "right" : ""}
                    name={getSender(conversation, msg)}
                    message={msg?.text}
                    msg={{
                      ...msg,
                      chatId: conversation?.conversationId,
                    }}
                    file={msg?.files}
                    pics={chatImages}
                    time={msg?.sentTime}
                    enableStarMsg={false}
                  />
                </div>
              )}
            </>
          ))
        : empty;
    } else {
      return !messageConsumer?.status?.get_messages?.loading && empty;
    }
  };

  useEffect(() => {
    if (messageConsumer?.status?.get_messages) {
      let get_messages = messageConsumer?.status?.get_messages;
      if (get_messages?.success) {
        updateChatImages(get_messages?.success?.chatId);
      }
    }
  }, [dispatch, messageConsumer]);

  useEffect(() => {
    if (update >= 0) {
      dispatch(resetConsumerObj()) &&
        chats?.consumer &&
        dispatch(getConsumerConversations(chats.consumer));
    }
  }, [update]);

  return (
    <>
      {chats?.status === "loading" ? (
        <div className="w-100 text-center">
          <Spinner animation="border" size="sm" className="spinner" />
        </div>
      ) : (
        chats?.data?.map((chat) => (
          <div
            key={chat?.conversationId}
            className={`mb-4 item ${
              collapse === chat?.conversationId && "item-opened"
            }`}
          >
            <div
              className="text-wrap pointer d-flex"
              onClick={() => {
                if (chat?.conversationId) {
                  toggle(chat.conversationId);
                  getMessages(chat.conversationId, 1);
                  updateChatImages(chat.conversationId);
                }
              }}
            >
              <i className="bx bx-right-arrow-circle color2 font-size-15 list-icon"></i>
              <div className="d-flex flex-column w-100 ml-2 pl-1">
                <div className="d-flex justify-content-between my-auto">
                  <div className="d-inline-flex order-1 chat-title">
                    {formatDate(chat?.created_at)}
                  </div>
                  <div className="d-inline-flex order-2 chat-csat">
                    CSAT: {chat?.csat ?? "-"}
                  </div>
                </div>
                <div className="order-3 pt-2 chat-user">
                  {chat?.users && chat.users.length > 0
                    ? chat.users[0].name
                    : null}
                </div>
              </div>
            </div>
            <Collapse
              isOpen={collapse === chat?.conversationId}
              className="px-3 mx-1"
            >
              {collapse === chat?.conversationId &&
                messageConsumer?.data?.id === chat?.conversationId &&
                messageConsumer?.status?.get_messages?.loading && (
                  <div className="w-100 py-3 text-center">
                    <Spinner
                      animation="border"
                      size="sm"
                      className="spinner my-2 smallSpinner"
                    />
                  </div>
                )}
              {showMessages(chat)}
            </Collapse>
          </div>
        ))
      )}
    </>
  );
};
export default withTranslation()(React.memo(EngagementHistoryArea));
